// TODO: capitalize/underscore Event types
// TODO: import Tom's question generation logic
// TODO: Use question result icons in last 5
// TODO: Use text-button modules across project

require('@babel/polyfill')
import * as constants from './constants'
import stage from './stage'
import Test from './test'
import * as ScreenManager from './screens/screen-manager'
if (window.parent !== window.self) require('./cm-communication')// Import only if in iframe. Using require not import overcomes circular dependencies
import Question from './questions/question'
import ChartQuestion from './questions/chart-question'
import GridQuestion from './questions/grid-question'
import MultiChoiceArrayQuestion from './questions/multi-choice-array-question'
import TextInputQuestion from './questions/text-input-question'

PIXI.settings.RESOLUTION = 2

;[ChartQuestion, GridQuestion, MultiChoiceArrayQuestion, TextInputQuestion].forEach(Q => Q.register())

// Create the renderer
const logicalWidth = constants.canvasWidth
const logicalHeight = constants.canvasHeight
const renderer = PIXI.autoDetectRenderer(logicalWidth, logicalHeight, {antialias: true, transparent: true})
stage.setRenderer(renderer)

// Add the canvas to the HTML document
const canvasWrapper = document.getElementById('canvas-wrapper')
canvasWrapper.appendChild(renderer.view)

exports.generateAndStartNewTest = ({timestables, numQuestions}) => {
  const questions = []
  const qTypes = ['CHART_QUESTION', 'GRID_QUESTION', 'MULTI_CHOICE_ARRAY_QUESTION', 'TEXT_INPUT_QUESTION']

  for (let i = 0; i < numQuestions; i++) {
    const type = qTypes[Math.floor(Math.random() * qTypes.length)]

    const n1 = timestables[Math.floor(Math.random() * timestables.length)]
    const n2 = Math.ceil(Math.random() * 12)

    const reverse = Math.random() < 0.5
    const [multiplicand, multiplier] = reverse ? [n1, n2] : [n2, n1]

    questions.push({type, multiplicand, multiplier})
  }

  startNewTest(timestables, questions)
};

exports.startNewTest = startNewTest

function startNewTest(timestables, serializedQuestions) {
  const deserializedQuestions = serializedQuestions.map(question => {
    const Q = Question.classForType(question.type)
    return new Q(question)
  })
  const test = new Test(timestables, deserializedQuestions)
  test.start()
}
